import { cva, VariantProps } from 'class-variance-authority';

import { semanticColor } from '../../theme/semanticColor';

const indeterminateProgressVariants = cva('animate-spin360', {
  variants: {
    variant: {
      circular: ''
    }
  },
  defaultVariants: {
    variant: 'circular'
  }
});

interface IndeterminateProgressProps extends VariantProps<typeof indeterminateProgressVariants> {
  className?: string;
  color?: 'primary' | 'inverse' | 'secondary' | 'dimmed' | 'dimmed-inverse';
  size?: number;
}

export function IndeterminateProgress({ variant, className, color = 'primary', size = 32, ...props }: IndeterminateProgressProps) {
  const getColor = () => {
    if (color === 'primary') {
      return semanticColor.primary.foreground.main;
    } else if (color === 'inverse') {
      return semanticColor.primary.foreground['inverse-main'];
    } else if (color === 'secondary') {
      return semanticColor.secondary.foreground.low;
    } else if (color === 'dimmed') {
      return semanticColor.neutral.foreground.disabled;
    } else if (color === 'dimmed-inverse') {
      return semanticColor.neutral.foreground['inverse-disabled'];
    }
    return semanticColor.primary.foreground.main;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      role={'status'}
      aria-label={'Loading, wait'}
      viewBox="0 0 32 32"
      className={indeterminateProgressVariants({ variant, className })}
      {...props}
    >
      <path
        d="M16 27.3333C9.74073 27.3333 4.66663 22.2592 4.66663 16C4.66663 9.74076 9.74073 4.66666 16 4.66666C22.2592 4.66666 27.3333 9.74076 27.3333 16H29.3333C29.3333 8.63619 23.3638 2.66666 16 2.66666C8.63616 2.66666 2.66663 8.63619 2.66663 16C2.66663 23.3638 8.63616 29.3333 16 29.3333V27.3333Z"
        fill={getColor()}
      />
    </svg>
  );
}
